import "../../../../shared/components/Timer/Timer.css";
import { formatExerciseTimer } from "../utils/exerciseExamUtils";

const DEFAULT_STYLE = { backgroundColor: "#EEF2FF", color: "#4F39F6" };
const WARNING_STYLE = { backgroundColor: "#FFE9C0", color: "#8C6400" };
const DANGER_STYLE = { backgroundColor: "#FFB5B5", color: "#B70000" };

const ExerciseTimer = ({ seconds = 0, isCountdown = false }) => {
  let timerStyle = DEFAULT_STYLE;

  if (isCountdown) {
    if (seconds <= 300) timerStyle = DANGER_STYLE;
    else if (seconds <= 600) timerStyle = WARNING_STYLE;
  }

  return (
    <div className="timer-container">
      <div className="timer-box" style={timerStyle}>
        <p>{formatExerciseTimer(seconds)}</p>
      </div>
    </div>
  );
};

export default ExerciseTimer;
